
    import './styles.scoped.css';
    export default {
  "input-adorned-container": "awsui_input-adorned-container_2rhyz_oxyq2_9",
  "input": "awsui_input_2rhyz_oxyq2_9",
  "input-adorned-container-readonly": "awsui_input-adorned-container-readonly_2rhyz_oxyq2_22",
  "input-readonly": "awsui_input-readonly_2rhyz_oxyq2_22",
  "root": "awsui_root_2rhyz_oxyq2_35",
  "input-invalid": "awsui_input-invalid_2rhyz_oxyq2_138",
  "input-has-icon-start": "awsui_input-has-icon-start_2rhyz_oxyq2_147",
  "input-warning": "awsui_input-warning_2rhyz_oxyq2_150",
  "input-type-search": "awsui_input-type-search_2rhyz_oxyq2_162",
  "input-has-icon-end": "awsui_input-has-icon-end_2rhyz_oxyq2_175",
  "input-has-no-border-radius": "awsui_input-has-no-border-radius_2rhyz_oxyq2_178",
  "grouped": "awsui_grouped_2rhyz_oxyq2_185",
  "grouped-horizontal-first": "awsui_grouped-horizontal-first_2rhyz_oxyq2_191",
  "grouped-horizontal-middle": "awsui_grouped-horizontal-middle_2rhyz_oxyq2_195",
  "grouped-horizontal-last": "awsui_grouped-horizontal-last_2rhyz_oxyq2_201",
  "grouped-vertical-first": "awsui_grouped-vertical-first_2rhyz_oxyq2_205",
  "grouped-vertical-middle": "awsui_grouped-vertical-middle_2rhyz_oxyq2_209",
  "grouped-vertical-last": "awsui_grouped-vertical-last_2rhyz_oxyq2_215",
  "grouped-with-action": "awsui_grouped-with-action_2rhyz_oxyq2_219",
  "input-container": "awsui_input-container_2rhyz_oxyq2_224",
  "input-icon-start": "awsui_input-icon-start_2rhyz_oxyq2_229",
  "input-icon-end": "awsui_input-icon-end_2rhyz_oxyq2_236",
  "input-button-right": "awsui_input-button-right_2rhyz_oxyq2_242",
  "inline-label-trigger-wrapper": "awsui_inline-label-trigger-wrapper_2rhyz_oxyq2_246",
  "inline-label-trigger-wrapper-full-width": "awsui_inline-label-trigger-wrapper-full-width_2rhyz_oxyq2_249",
  "inline-label-wrapper": "awsui_inline-label-wrapper_2rhyz_oxyq2_253",
  "inline-label-wrapper-full-width": "awsui_inline-label-wrapper-full-width_2rhyz_oxyq2_256",
  "inline-label": "awsui_inline-label_2rhyz_oxyq2_246",
  "inline-label-disabled": "awsui_inline-label-disabled_2rhyz_oxyq2_281",
  "input-adorned-container-disabled": "awsui_input-adorned-container-disabled_2rhyz_oxyq2_306",
  "input-adorned-container-invalid": "awsui_input-adorned-container-invalid_2rhyz_oxyq2_314",
  "input-adorned-container-warning": "awsui_input-adorned-container-warning_2rhyz_oxyq2_327",
  "input-prefix": "awsui_input-prefix_2rhyz_oxyq2_341",
  "input-suffix": "awsui_input-suffix_2rhyz_oxyq2_342",
  "input-adornment-content": "awsui_input-adornment-content_2rhyz_oxyq2_355",
  "input-adornment-divider": "awsui_input-adornment-divider_2rhyz_oxyq2_364",
  "input-adorned": "awsui_input-adorned_2rhyz_oxyq2_9"
};
  